import type { LoadHtmlImage } from "./types";

export const loadHtmlImage: LoadHtmlImage = ({ src }) =>
  new Promise((resolve, reject) => {
    const image = new Image();
    image.crossOrigin = "anonymous";
    image.onload = () => resolve(image);
    image.onerror = () => reject(new Error(`Failed to load ${src}`));
    image.src = src;
  });
